import { BASE_URL } from '../../../../config/environmentConfig';
import { sendSentryMessage } from '../../../utils/sentry-helper';
import * as Sentry from '@sentry/react';
import { paymentsActionTypes } from '../payments-action-types';
import { IPaymentsAction } from '../payments-interfaces';
import * as React from 'react';
import { GET } from '../../store-helper';
import { IBatchesFiltersParams } from '../../../components/batches/BatchesFilterSection';

interface IFetchBatchesProps {
  dispatch: React.Dispatch<IPaymentsAction>;
  params: IBatchesFiltersParams;
}

export const fetchUnpostedBatchData = async ({ dispatch, params }: IFetchBatchesProps): Promise<void> => {
  try {
    dispatch({ type: paymentsActionTypes.SET_UNPOSTED_BATCHES_DATA_LOADING, payload: true });

    const requestParams = { ...params };

    if (requestParams?.query) {
      requestParams.merchantid = requestParams.query;
      delete requestParams.query;
    }

    delete requestParams?.showAll;

    const data = await GET({
      pathname: `${BASE_URL.ORDERS}/payouts`,
      params: requestParams,
    });
    dispatch({ type: paymentsActionTypes.FETCH_UNPOSTED_BATCHES_DATA, payload: data ?? [] });

    return data;

  } catch (e) {
    Sentry.setTag('fetch-payout-data-id', params?.merchantid);
    sendSentryMessage({ name: `GET Fetch payout data error`, context: e });
    console.log(e);
  }
};

export const fetchBatchData = async ({ dispatch, params }: IFetchBatchesProps): Promise<void> => {
  try {

    dispatch({ type: paymentsActionTypes.SET_BATCHES_DATA_LOADING, payload: true });

    const requestParams = { ...params };

    if (requestParams?.query) {
      requestParams.merchantid = requestParams.query;
      delete requestParams.query;
    }

    delete requestParams?.showAll;

    const data = await GET({
      pathname: `${BASE_URL.ORDERS}/payouts/pending`,
      params: requestParams,
    });

    dispatch({ type: paymentsActionTypes.FETCH_BATCHES_DATA, payload: data ?? [] });
  } catch (e) {
    Sentry.setTag('fetch-pending-payout-data-id', params?.merchantid);
    sendSentryMessage({ name: `GET Fetch pending payout data error`, context: e });
    console.log(e);
  }
};

export const setBatchesDataToDefault = (dispatch: React.Dispatch<IPaymentsAction>): void => {
  dispatch({ type: paymentsActionTypes.SET_BATCHES_TO_DEFAULT });
};

export const fetchShelvedBatchesData = async ({ dispatch, params }: IFetchBatchesProps): Promise<void> => {
  try {
    dispatch({ type: paymentsActionTypes.SET_SHELVED_BATCHES_DATA_LOADING, payload: true });

    const requestParams = { ...params };

    if (requestParams.query) {
      requestParams.mid = requestParams.query;
      delete requestParams.query;
    }

    delete requestParams?.showAll;

    const data = await GET({ pathname: `${BASE_URL.ORDERS}/payouts/shelve`, params: requestParams });

    dispatch({ type: paymentsActionTypes.FETCH_SHELVED_BATCHES_DATA, payload: data ?? [] });

  } catch (e) {
    Sentry.setTag('fetch-pending-payout-data-id', params?.mid || params?.query);
    sendSentryMessage({ name: `GET Fetch pending payout data error`, context: e });
    console.log(e);
  }
};
